import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';
import MaskedInput, { dateMask } from '../MaskedInput';

const FORMAT = 'MM/DD/YYYY';
const MAX_INPUT_LENGTH = 10;

export const addSlashes = value => {
  if (!value) {
    return value;
  }

  const match = new RegExp(
    FORMAT.replace(/(\w+)\W(\w+)\W(\w+)/, '^\\s*($1)\\W*($2)?\\W*($3)?([0-9]*).*').replace(
      /M|D|Y/g,
      '\\d',
    ),
  );
  const replace = '$1/$2/$3$4'.replace(/\//g, FORMAT.match(/\W/));

  const prettyValue = value
    .replace(/(^|\W)(?=\d\W)/g, '$10') // padding
    .replace(match, replace) // fields
    .replace(/(\W)+/g, '$1'); // remove repeats

  return prettyValue.substring(0, MAX_INPUT_LENGTH);
};

export const setDay = day => {
  const minDay = 1;
  const maxDay = 31;

  if (parseInt(day, 10) < minDay) {
    return minDay;
  }
  if (parseInt(day, 10) > maxDay) {
    return maxDay;
  }

  return day;
};

export const setMonth = month => {
  const minMonth = 1;
  const maxMonth = 12;

  if (parseInt(month, 10) < minMonth) {
    return minMonth;
  }
  if (parseInt(month, 10) > maxMonth) {
    return maxMonth;
  }
  return month;
};

export const setYear = year => {
  const minYear = 1900;
  return parseInt(year, 10) < minYear ? minYear : year;
};

export const getMinDateValues = value => {
  if (!/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(value)) {
    return '';
  }
  const month = setMonth(value.substring(0, 2));
  const day = setDay(value.substring(3, 5));
  const year = setYear(value.substring(6));

  const date = moment(new Date(`${month}/${day}/${year}`));
  if (date.isValid()) {
    return moment(date).format(FORMAT);
  }
  return '';
};

const MaskedDateInput = props => <MaskedInput {...props} mask={dateMask} guide={false} />;

class DateInputView extends Component {
  constructor(props) {
    super(props);
    const { value } = this.props;

    const valueFormated = moment(value).format(FORMAT);

    this.state = {
      dateValue: value ? valueFormated : value,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const valueFormated = moment(this.props.value).format(FORMAT);

      this.setState({ dateValue: this.props.value ? valueFormated : this.props.value });
    }
  }

  render() {
    const { name, onChange, onFocus, placeholder, onBlur, hasMask, maxDate, id } = this.props;
    const { dateValue } = this.state;

    return (
      <DayPickerInput
        {...this.props}
        placeholder={placeholder || FORMAT}
        value={dateValue}
        formatDate={formatDate}
        parseDate={parseDate}
        format={FORMAT}
        onDayChange={date => {
          onChange(date);
        }}
        inputProps={{
          name,
          maxLength: MAX_INPUT_LENGTH,
          'aria-labelledby': id,
          onFocus,
          onChange: ({ target }) =>
            this.setState({
              dateValue: target.value,
            }),
          onBlur: event => {
            const { value } = event.target;

            if (value) {
              const dateFormated = addSlashes(value);
              const date = getMinDateValues(dateFormated);

              this.setState({
                dateValue: date,
              });
              onChange(date);
            }
            if (onBlur) {
              onBlur(event);
            }
          },
          onKeyPress: event => {
            const ENTER_KEY_CODE = 13;
            const key = parseInt(event.keyCode, 10) || parseInt(event.charCode, 10);
            if (key === ENTER_KEY_CODE) {
              event.currentTarget.blur();
            }
          },
        }}
        component={hasMask ? MaskedDateInput : undefined}
        dayPickerProps={{
          ...(maxDate && {
            disabledDays: { after: maxDate },
          }),
        }}
      />
    );
  }
}

DateInputView.defaultProps = {
  placeholder: null,
  value: null,
  name: null,
  onFocus: () => {},
  onBlur: () => {},
  hasMask: false,
};

DateInputView.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  hasMask: PropTypes.bool,
};

export default DateInputView;
